import React from "react";
/*import './CollapsibleSection.css';*/
const TOUCH_THRESHOLD = 10;

class CollapsibleSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      open: this.props.defaultOpen || false, 
      touchTriggered: false, 
      touchStartY: 0
    };
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onClick = this.onClick.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  
  componentDidMount() {
    // Try to restore state from localStorage
    const storageKey = this.getStorageKey();
    const savedState = localStorage.getItem(storageKey);
    if (savedState !== null) {
      this.setState({ open: JSON.parse(savedState) });
    }
  }
  
  getStorageKey() {
    // Create a unique key based on section name only
    const sectionName = this.props.sectionName || 'section';
    return `collpasible-section-${sectionName}`;
  }

  onTouchStart(e) {
    this.setState({
      touchTriggered: true,
      touchStartY: e.touches[0].clientY
    });
  }

  onTouchEnd(e) {
    if(this.state.touchTriggered) {
      const touchEndY = e.changedTouches[0].clientY;
      const distance = Math.abs(touchEndY - this.state.touchStartY);
      if (distance < TOUCH_THRESHOLD) {
        // Considered a tap, not a scroll
        this.toggle();
      }
    }
  }

  onClick() {
    if(!this.state.touchTriggered) {
      this.toggle();
    } else {
      this.setState({
        touchTriggered: false
      });
    }
  }
  
  toggle() {
    this.setState((prev) => {
      const newState = { open: !prev.open };
      // Save state to localStorage
      localStorage.setItem(this.getStorageKey(), JSON.stringify(newState.open));
      return newState;
    });
  }

  getExpandArrowColour() {
    return this.props.arrowColour == null ? 'var(--layout-border-colour)' : this.props.arrowColour;
  }

  renderOpen() {
    return <svg stroke={this.getExpandArrowColour()} fill={this.getExpandArrowColour()} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 122.881 122.88" enableBackground="new 0 0 122.881 122.88" xmlSpace="preserve"><g><path d="M56.573,4.868c0-0.655,0.132-1.283,0.37-1.859c0.249-0.6,0.61-1.137,1.056-1.583C58.879,0.545,60.097,0,61.44,0 c0.658,0,1.287,0.132,1.863,0.371c0.012,0.005,0.023,0.011,0.037,0.017c0.584,0.248,1.107,0.603,1.543,1.039 c0.881,0.88,1.426,2.098,1.426,3.442c0,0.03-0.002,0.06-0.006,0.089v51.62l51.619,0c0.029-0.003,0.061-0.006,0.09-0.006 c0.656,0,1.285,0.132,1.861,0.371c0.014,0.005,0.025,0.011,0.037,0.017c0.584,0.248,1.107,0.603,1.543,1.039 c0.881,0.88,1.428,2.098,1.428,3.441c0,0.654-0.133,1.283-0.371,1.859c-0.248,0.6-0.609,1.137-1.057,1.583 c-0.445,0.445-0.98,0.806-1.58,1.055v0.001c-0.576,0.238-1.205,0.37-1.861,0.37c-0.029,0-0.061-0.002-0.09-0.006l-51.619,0.001 v51.619c0.004,0.029,0.006,0.06,0.006,0.09c0,0.656-0.133,1.286-0.371,1.861c-0.006,0.014-0.012,0.025-0.018,0.037 c-0.248,0.584-0.602,1.107-1.037,1.543c-0.883,0.882-2.1,1.427-3.443,1.427c-0.654,0-1.283-0.132-1.859-0.371 c-0.6-0.248-1.137-0.609-1.583-1.056c-0.445-0.444-0.806-0.98-1.055-1.58h-0.001c-0.239-0.575-0.371-1.205-0.371-1.861 c0-0.03,0.002-0.061,0.006-0.09V66.303H4.958c-0.029,0.004-0.059,0.006-0.09,0.006c-0.654,0-1.283-0.132-1.859-0.371 c-0.6-0.248-1.137-0.609-1.583-1.056c-0.445-0.445-0.806-0.98-1.055-1.58H0.371C0.132,62.726,0,62.097,0,61.44 c0-0.655,0.132-1.283,0.371-1.859c0.249-0.6,0.61-1.137,1.056-1.583c0.881-0.881,2.098-1.426,3.442-1.426 c0.031,0,0.061,0.002,0.09,0.006l51.62,0l0-51.62C56.575,4.928,56.573,4.898,56.573,4.868L56.573,4.868z"/></g></svg>
  }

  renderClose() {
    return <svg stroke={this.getExpandArrowColour()} fill={this.getExpandArrowColour()} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="9.737px" viewBox="0 0 122.881 9.737" enableBackground="new 0 0 122.881 9.737" xmlSpace="preserve"><g><path d="M117.922,0.006C117.951,0.002,117.982,0,118.012,0c0.656,0,1.285,0.132,1.861,0.371c0.014,0.005,0.025,0.011,0.037,0.017 c0.584,0.248,1.107,0.603,1.543,1.039c0.881,0.88,1.428,2.098,1.428,3.441c0,0.654-0.133,1.283-0.371,1.859 c-0.248,0.6-0.609,1.137-1.057,1.583c-0.445,0.445-0.98,0.806-1.58,1.055v0.001c-0.576,0.238-1.205,0.37-1.861,0.37 c-0.029,0-0.061-0.002-0.09-0.006c-37.654,0-75.309,0.001-112.964,0.001c-0.029,0.004-0.059,0.006-0.09,0.006 c-0.654,0-1.283-0.132-1.859-0.371c-0.6-0.248-1.137-0.609-1.583-1.056C0.981,7.865,0.621,7.33,0.372,6.73H0.371 C0.132,6.154,0,5.525,0,4.869C0,4.215,0.132,3.586,0.371,3.01c0.249-0.6,0.61-1.137,1.056-1.583 c0.881-0.881,2.098-1.426,3.442-1.426c0.031,0,0.061,0.002,0.09,0.006C42.613,0.006,80.268,0.006,117.922,0.006L117.922,0.006z"/></g></svg>
  }

  renderOpenOrClosed() {
    if(this.props.collapsible == null || this.props.collapsible == true) {
      let icon;
      if(this.state.open) {
        icon = this.renderClose();
      } else {
        icon = this.renderOpen();
      }
      return <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }}
        >
        {icon}
      </div>
    }
  }

  renderCollapsibleContent() {
    if(this.props.collapsible == null || this.props.collapsible == true) {
      if(this.state.open) {
        return <div className="collapsible-content">{this.props.children}</div>;
      }
    }
  }
  
  render() {
    let showHeader = this.props.header != null;
    const rootClass = "collapsible-section" + (this.state.open ? " open" : " closed") + (this.props.className ? " " + this.props.className : "");
    let cursor = (this.props.collapsible == null || this.props.collapsible == true) ? 'pointer' : '';
    return (
      <div className={rootClass}>
        {showHeader && (
          <div
            className="collapsible-header"
            onClick={this.onClick}
            onTouchStart={this.onTouchStart}
            onTouchEnd={this.onTouchEnd}
            style={{ cursor: cursor, userSelect: 'none', display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}
          >
            {this.props.header}
            <div style={{ flex: 1 }} />
            {this.renderOpenOrClosed()}
          </div>
        )}
        {this.renderCollapsibleContent()}
      </div>
    );
  }
}

export default CollapsibleSection;